import axios from "axios";
import { getToken } from "../Utils/UpdateUsersState";

const login = async (data) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}token/`,
      data
    );
    return res;
  } catch (e) {
    console.log(e);
    return e;
  }
};

const refresh = async (refresh) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}token/refresh/`,
      { refresh },
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e;
  }
};

const checkApiKeyValidity = async () => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}token/api_key/validity/`,
      {},
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e;
  }
};

const sendVerificationLink = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}verification/resend/`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e;
  }
};

const verify = async (id) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}verify/${id}/`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e;
  }
};

const forgotPassword = async (email) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}forgot-password/`,
      {
        email,
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e;
  }
};

const updatePassword = async (id, password) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}reset-password/${id}/`,
      {
        password,
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e;
  }
};

export {
  login,
  refresh,
  checkApiKeyValidity,
  sendVerificationLink,
  verify,
  forgotPassword,
  updatePassword,
};
